import moment from "moment";
import { DATE_FORMATS } from "./Constant";

export const getAge = (birthDate) => {
  return moment().diff(birthDate, "years");
};

export const getActualYear = () => {
  return new Date().getFullYear();
};

export const getActualDate = () => {
  return moment().format(DATE_FORMATS.middledash_ymd);
};

export const esFechaDelDiaActual = (fechaISO) => {
  if (!fechaISO) return false;
  const fecha = moment(fechaISO);
  const hoy = moment();
  return fecha.isSame(hoy, "day");
};

export const estaHoraEntreRango = (fechaHoraInicio, fechaHoraFin) => {
  if (!fechaHoraInicio || !fechaHoraFin) return false;
  
  const ahora = moment();
  const horaActual = ahora.format("HH:mm");
  
  const inicio = moment(fechaHoraInicio, "HH:mm", true);
  const fin = moment(fechaHoraFin, "HH:mm", true);
  const horaActualMoment = moment(horaActual, "HH:mm", true);
  
  if (!inicio.isValid() || !fin.isValid() || !horaActualMoment.isValid()) {
    return false;
  }
  
  if (inicio.isBefore(fin) || inicio.isSame(fin)) {
    return horaActualMoment.isSameOrAfter(inicio, "minute") && horaActualMoment.isSameOrBefore(fin, "minute");
  } else {
    return horaActualMoment.isSameOrAfter(inicio, "minute") || horaActualMoment.isSameOrBefore(fin, "minute");
  }
};